export default class GameScoreUnity {
    constructor(gs, unity) {
        this.gs = gs;
        this.unity = unity;

        this.gs.ads.on('rewarded:reward', () => this.trigger('CallAdsRewardedReward', this.lastRewardedTag));

        // socials
        this.gs.socials.on('share', (success) => this.trigger('CallSocialsShare', success));
        this.gs.socials.on('post', (success) => this.trigger('CallSocialsPost', success));
        this.gs.socials.on('invite', (success) => this.trigger('CallSocialsInvite', success));
        this.gs.socials.on('joinCommunity', (success) => this.trigger('CallSocialsJoinCommunity', success));

		this.gs.ads.on('start', () => this.trigger('CallAdsStart'));
        this.gs.ads.on('close', (success) => {
            this.trigger('CallAdsClose', success);
            window.focus();
        });
		
        // gs
        this.gs.on('pause', () => this.trigger('CallOnPause'));
        this.gs.on('resume', () => this.trigger('CallOnResume'));
    }
    trigger(eventName, value) {

        this.unity.SendMessage('GameScoreSDK', eventName, this.toUnity(value));
    }

    toUnity(value) {
        switch (typeof (value)) {
            case 'boolean': {
                return String(value);
            }
            case 'number': {
                return value;
            }
            case 'string': {
                return value;
            }
            case 'object': {
                return JSON.stringify(value);
            }
        }
        return value;
    }

    Language() {
        return this.gs.language;
    }
    PlatformType() {
        return this.gs.platform.type;
    }
    PlatformHasIntegratedAuth() {
        return this.toUnity(this.gs.platform.hasIntegratedAuth);
    }
    PlatformIsExternalLinksAllowed() {
        return this.toUnity(this.gs.platform.isExternalLinksAllowed);
    }

    LeaderboardOpen(orderBy, order, limit, withMe, includeFields, displayFields) {
        return this.gs.leaderboard
            .open({
                id: this.gs.player.id,
                orderBy: orderBy
                    .split(',')
                    .map((o) => o.trim())
                    .filter((f) => f),
                order,
                limit: Number(limit),
                withMe,
                includeFields: includeFields
                    .split(',')
                    .map((o) => o.trim())
                    .filter((f) => f),
                displayFields: displayFields
                    .split(',')
                    .map((o) => o.trim())
                    .filter((f) => f),
            })
            .catch(console.warn);
    }

    LeaderboardFetchPlayerRating(tag, orderBy, order) {
        return this.gs.leaderboard
            .fetchPlayerRating({
                id: this.gs.player.id,
                orderBy: orderBy
                    .split(',')
                    .map((o) => o.trim())
                    .filter((f) => f),
                order,
            })
            .then((result) => {
                this.trigger('CallLeaderboardFetchPlayerTag', tag);
                this.trigger('CallLeaderboardFetchPlayer', result.player.position);
            })
            .catch((err) => {
                console.warn(err);
                this.trigger('CallLeaderboardFetchPlayerError');
            });
    }




    /* LEADER BOARD SCOPED */

    LeaderboardScopedOpen(id, tag, variant, order, limit, withMe, includeFields, displayFields) {
        return this.gs.leaderboard
            .openScoped({
                id: Number(id),
                tag,
                variant,
                order,
                limit: Number(limit),
                includeFields: includeFields
                    .split(',')
                    .map((o) => o.trim())
                    .filter((f) => f),
                displayFields: displayFields
                    .split(',')
                    .map((o) => o.trim())
                    .filter((f) => f),
                withMe,
            })
            .catch(console.warn);
    }

    LeaderboardScopedPublishRecord(id, tag, variant, override, Score, Level, Exp) {
        return this.gs.leaderboard
            .publishRecord({
                id: Number(id),
                tag,
                variant,
                override: Boolean(override),
                record: {
                    score: Number(Score),
                    level: Number(Level),
                    exp: Number(Exp),
                },

            })
            .then(() => {
                this.trigger('CallLeaderboardScopedPublishRecordComplete');
            })
            .catch((err) => {
                console.warn(err);
                this.trigger('CallLeaderboardScopedPublishRecordError');
            });
    }

    LeaderboardScopedFetchPlayerRating(id, tag, variant, includeFields) {
        return this.gs.leaderboard
            .fetchPlayerRatingScoped({
                id: Number(id),
                tag,
                variant,
                includeFields: includeFields
                    .split(',')
                    .map((o) => o.trim())
                    .filter((f) => f),
            })
            .then((result) => {
                this.trigger('CallLeaderboardScopedFetchPlayerTag', tag);
                this.trigger('CallLeaderboardScopedFetchPlayerVariant', variant);
                this.trigger('CallLeaderboardScopedFetchPlayer', result.player.position);
            })
            .catch((err) => {
                console.warn(err);
                this.trigger('CallLeaderboardFetchPlayerError');
            });
    }
    /* LEADER BOARD SCOPED */



    AchievementsOpen() {
        return this.gs.achievements.open().catch(console.warn);
    }

    AchievementsUnlock(idOrTag) {
        const id = parseInt(idOrTag, 10) || 0;
        const query = id > 0 ? { id } : { tag: idOrTag };
        return this.gs.achievements
            .unlock(query)
            .then((result) => {

                if (result.success) {
                    this.trigger('CallAchievementsUnlock', idOrTag);
                    return;
                }

                this.trigger('CallAchievementsUnlockError');
            })

            .catch((err) => {
                console.warn(err);
                this.trigger('CallAchievementsUnlockError');
            });
    }

    AdsShowFullscreen() {
        return this.gs.ads.showFullscreen();
    }
    AdsShowRewarded(idOrTag) {
        this.lastRewardedTag = idOrTag;
        return this.gs.ads.showRewardedVideo();
    }

    AdsShowSticky() {
        return this.gs.ads.showSticky();
    }
    AdsCloseSticky() {
        return this.gs.ads.closeSticky();
    }
    AdsRefreshSticky() {
        return this.gs.ads.refreshSticky();
    }


    AdsIsAdblockEnabled() {
        return this.toUnity(this.gs.ads.isAdblockEnabled);
    }

    AdsIsRewardedAvailable() {
        return this.toUnity(this.gs.ads.isRewardedAvailable);
    }


    SocialsShare(text, url, image) {
        return this.gs.socials.share({ text, url, image });
    }
    SocialsPost(text, url, image) {
        return this.gs.socials.post({ text, url, image });
    }
    SocialsInvite(text, url, image) {
        return this.gs.socials.invite({ text, url, image });
    }
    SocialsJoinCommunity() {
        return this.gs.socials.joinCommunity();
    }
    SocialsCommunityLink() {
        return this.toUnity(this.gs.socials.communityLink);
    }


    SocialsIsSupportsNativeShare() {
        return this.toUnity(this.gs.socials.isSupportsNativeShare);
    }
    SocialsIsSupportsNativePosts() {
        return this.toUnity(this.gs.socials.isSupportsNativePosts);
    }
    SocialsIsSupportsNativeInvite() {
        return this.toUnity(this.gs.socials.isSupportsNativeInvite);
    }
    SocialsCanJoinCommunity() {
        return this.toUnity(this.gs.socials.canJoinCommunity);
    }
    SocialsIsSupportsNativeCommunityJoin() {
        return this.toUnity(this.gs.socials.isSupportsNativeCommunityJoin);
    }

    // games collections
    GamesCollectionsOpen(idOrTag) {
        const id = parseInt(idOrTag, 10) || 0;
        const query = id > 0 ? { id } : { tag: idOrTag || 'ANY' };
        return this.gs.gamesCollections.open(query);
    }



    // GAME
    Pause() {
        return this.gs.pause();
    }
    Resume() {
        return this.gs.resume();
    }
    // GAME


    //Device
    IsMobile() {
        return this.toUnity(this.gs.isMobile);
    }
    //Device


    // Server
    ServerTime() {
        return this.toUnity(this.gs.serverTime);
    }
    // Server
}

window.GameScoreUnity = GameScoreUnity;
